import api from '../api/axios'

export const secureDownload = async (type, storedName, originalName) => {
   if (!storedName) return

   const response = await api.get(
      `/download/${type}/${encodeURIComponent(storedName)}`,
      {
         responseType: 'blob',
      }
   )

   const blob = new Blob([response.data], {
      type: response.headers['content-type'] || 'application/octet-stream',
   })

   const url = window.URL.createObjectURL(blob)
   const link = document.createElement('a')

   link.href = url
   link.download = originalName || storedName

   document.body.appendChild(link)
   link.click()
   link.remove()

   window.URL.revokeObjectURL(url)
}
